"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserGroup = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const isEqual_1 = __importDefault(require("lodash/isEqual"));

const pick_1 = __importDefault(require("lodash/pick"));

const Member_1 = require("../member/Member");

const types_1 = require("../types");

class UserGroup extends Member_1.Member {
  constructor(options = {}) {
    super(options);
    Object.assign(this, pick_1.default(options, ['adminCount', 'description', 'id', 'name', 'orgId', 'userCount', 'externallyManaged']), {
      administerable: options.administerable === undefined || options.administerable,
      type: options.type || types_1.MEMBER_TYPE.USER_GROUP
    });
    this.registerSavedState();
  }
  /**
   * @description Method to retrieve the name of this user group.
   *
   * @returns {String} Name of user group
   */


  getDisplayName() {
    return this.name;
  }
  /**
   * @description Method to determine whether editable fields have been modified.
   * @returns {Boolean} return true if local copy has been modified.
   */


  hasUnsavedChanges() {
    return !isEqual_1.default(this.toMinimumModel(), this.savedState);
  }
  /**
   * @description Method to determine if this user group instance
   *              is isAdministerable by the currently signed-in user.
   *
   * @returns {boolean} true if UserGroup administerable, else false
   */


  isAdministerable() {
    return this.administerable;
  }
  /**
   * @description Method to determine if this user group is editable.
   *
   * @returns {boolean} true if the currently user cand administer the group
   *                    and the group is not coming from an externaly system
   *                    false otherwise.
   */


  isEditable() {
    return this.isAdministerable() && !this.isExternallyManaged();
  }
  /**
   * @description Method to determine if this group has been created in an
   *              external system (e.g. Azure)
   *
   * @returns {boolean} true if the group comes from an external system, false otherwise
   */


  isExternallyManaged() {
    return this.externallyManaged;
  }
  /**
   * @description Method to update model with a nested form of itself recording state
   *     which may be later modified.
   */


  registerSavedState() {
    this.savedState = this.isNew() ? {} : this.toMinimumModel();
  }
  /**
   * @description Method to construct a minimum data object from the model.
   *
   * @returns {Object} Reference to minimum data object
   */


  toMinimumModel() {
    return {
      description: this.description,
      id: this.id,
      name: this.name
    };
  }

}

exports.UserGroup = UserGroup;